import { render, staticRenderFns } from "./NewMoment.vue?vue&type=template&id=326ed35c&"
import script from "./NewMoment.vue?vue&type=script&lang=js&"
export * from "./NewMoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports